import { Typography } from '@mui/material';
import JobDTO from '@src/adapters/dto/job/JobDTO';
import useCachedProductionList from '@src/adapters/hooks/production/useCachedProductionList';
import Job from '@src/pages/Job';
import { useEffect, useState } from 'react';

interface Props {
  job: JobDTO;
}

function JobSelectionItem({ job }: Props) {
  const { getList } = useCachedProductionList();
  const [productionName, setProductionName] = useState('');

  useEffect(() => {
    getList(job.productionId).then((production) => {
      if (production && production.length === 1) {
        setProductionName(production[0].name);
      }
    });
  }, [getList, job.productionId]);

  return (
    <Typography>
      {productionName} ({job.role.name})
    </Typography>
  );
}

export default JobSelectionItem;
